export default __webpack_public_path__ + "static/media/rewimage.d23879b8.jpg";